import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_CLIENT_ID || '';
const authority = process.env.REACT_APP_AUTHORITY || '';
const scopes = (process.env.REACT_APP_SCOPES || '').split(' ');
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage', // "sessionStorage" or "localStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        console.log(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes,
};
